<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { ControlsContainer, Slider } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Helpers
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	//Components
	import TemplateStatuses from './components/TemplateStatuses.svelte';
	import TemplateDirectionButton from './components/TemplateDirectionButton.svelte';
	import TemplateDirectionControlButtons from './components/TemplateDirectionControlButtons.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, statuses: VCInterfaceStatus[];

	let isLoading: boolean = false;
	let valueBeforeSend: number = null;
	let statusPosition: VCInterfaceStatus | undefined;
	let statusStop: VCInterfaceStatus | undefined;
	let statusCover: VCInterfaceStatus | undefined;
	let value: number = 0;

	$: if (statuses) {
		statusPosition = statuses.find((i) => /^(position)$/.test(i.role));
		statusStop = statuses.find((i) => /^(stop)$/.test(i.role));
		statusCover = statuses.find((i) => /^(status)$/.test(i.role));
		value = valueBeforeSend !== null ? valueBeforeSend : statusPosition?.event || 0;
		if (!isLoading && valueBeforeSend !== null && statusPosition?.event == valueBeforeSend) {
			valueBeforeSend = null;
		}
	}

	const changePosition = async (value: number) => {
		isLoading = true;
		valueBeforeSend = value;
		const res: SettingRequest = await gen2Request(device, 'Number.set', {
			id: statusPosition.id,
			value,
		});
		if (!res?.isok) {
			valueBeforeSend = null;
			onSettingsResponse(res, device);
		}
		isLoading = false;
	};
</script>

<TemplateStatuses {statuses} templateRoles={['status']} />

<div class="flex-full-height justify-content-end">
	{#if statusPosition?.id}
		<Slider
			id="slider-windows-cover-position"
			a11yProps={{
				ariaLabel: 'Slider',
				ariaLabelValue: 'Value of slider',
			}}
			class="flex-full-height mb-l"
			title={value == 0
				? capFirstChar($format(`slider_title_state_closing`, { default: 'closing' }))
				: capFirstChar($format('slider_title_state_opened', { default: 'opened' }))}
			{value}
			{isLoading}
			step={Number(statusPosition?.step || 1)}
			on:value_change={(e) => {
				changePosition(e.detail.value);
			}}
			unit={statusPosition.unit || ''}
		/>
	{/if}

	{#if statusStop?.id && !statusCover?.id}
		<ControlsContainer color={$showNewLayout ? 'color-0' : undefined}>
			<TemplateDirectionButton
				size="m"
				direction="open"
				slot="first"
				{device}
				{statuses}
				title={$format('text_device_control_direction_open', {
					default: 'Open',
				})}
			/>
			<TemplateDirectionButton
				size="m"
				direction="stop"
				slot="second"
				{device}
				{statuses}
				title={$format('text_device_control_direction_stop', {
					default: 'Stop',
				})}
			/>
			<TemplateDirectionButton
				size="m"
				direction="close"
				slot="third"
				{device}
				{statuses}
				title={$format('text_device_control_direction_close', {
					default: 'Close',
				})}
			/>
		</ControlsContainer>
	{:else}
		<TemplateDirectionControlButtons {device} {statuses} />
	{/if}
</div>
